import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=20f17f92&scoped=true"
import script from "./SearchBar.ts?vue&type=script&lang=ts&external"
export * from "./SearchBar.ts?vue&type=script&lang=ts&external"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=20f17f92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f17f92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f17f92')) {
      api.createRecord('20f17f92', component.options)
    } else {
      api.reload('20f17f92', component.options)
    }
    module.hot.accept("./SearchBar.vue?vue&type=template&id=20f17f92&scoped=true", function () {
      api.rerender('20f17f92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Searcher/components/SearchBar/SearchBar.vue"
export default component.exports